<div class="ban-driver-dialog">
  <h2>Suspend {{ data.driver.name }}</h2>
  <div class="text-gray-700">Reason</div>
  <mat-form-field class="form-field w-full" appearance="outline">
    <textarea
      class="w-full"
      matInput
      maxlength="1000"
      matAutosizeMinRows="5"
      matAutosizeMaxRows="5"
      matTextareaAutosize
      [formControl]="reasonControl"
    >
    </textarea>
  </mat-form-field>
  <div>
    By suspending {{ data.driver.name }}, the driver will no longer be able to run loads for any
    {{ accountName$ | async }} jobs.
  </div>
  <div class="flex flex-row justify-end gap-1 mt-1">
    <button mat-flat-button color="warn" [disabled]="!reasonControl.value" (click)="suspendDriver()">
      SUSPEND
    </button>
    <button mat-flat-button color="primary" (click)="closeDialog()">
      CANCEL
    </button>
  </div>
</div>
